<template>
  <a-cascader @change="changeXzc" expandTrigger="hover" :allowClear="false" :value="getValueSting" :disabled="disabled" :changeOnSelect="changeOnSelect" :options="options" :placeholder="placeholder" />
</template>
<script>
// import { pcaa } from 'area-data'
// import Area from '@/components/_util/Area'
import { getSsqJson } from '@/api/manage'


export default {
  name: 'OrgSelect',
  props: {
    value: String,
    placeholder: String,
    changeOnSelect:{
      type:Boolean,
      default:false
    },
    getPopupContainer:{
      type: Function,
      default: (node) => node.parentNode
    },
    sfssq:{
      type:Boolean,
      default:false
    },
    disabled:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      options: [],
      defaultValue:[],
      reloading: false,
      areaData:''
    }
  },
  created() {
    this.$nextTick(() => {
      this.initAreaData();
    })
  },
  computed: {
      getValueSting(){
        // update-begin author:wangshuai date:20200601 for: 不显示placeholder的文字 ------
        // 当有null或“” placeholder不显示
        if(this.value != null){
          var defaultValueThis = [];
          if(this.options.length>0){
            if(this.value.indexOf("81")==0){
              defaultValueThis.push("91");
              for(var i=1;i<(this.value.length)/2;i++){
                if(i==2){
                  defaultValueThis.push(this.value);
                }else{
                  defaultValueThis.push(this.value.substr(0,(i+1)*2));
                }
              }
            }else if(this.value.indexOf("82")==0){
              defaultValueThis.push("91");
              for(var i=1;i<(this.value.length)/2;i++){
                if(i==2){
                  defaultValueThis.push(this.value);
                }else{
                  defaultValueThis.push(this.value.substr(0,(i+1)*2));
                }
              }
            }else{
              for(var i=0;i<(this.value.length)/2;i++){
                if(i==2){
                  defaultValueThis.push(this.value);
                }else{
                  defaultValueThis.push(this.value.substr(0,(i+1)*2));
                }
              }
            }
          }
          return defaultValueThis;
        }else{
          return undefined;
        }
        // update-end author:wangshuai date:20200601 for: 不显示placeholder的文字 ------
      },
  },
  methods: {
    changeXzc(value) {
      this.defaultValue = value;
      var val='';
      if(value.length>0){
        val=value[value.length-1];
      }
      this.value = val;
      this.$emit('input', val);
      this.$emit('change', val);
    },
    initAreaData(){
        let that = this;
        getSsqJson().then((res)=>{
          let arr = []
          const province = res['86']
          Object.keys(province).map(key=>{
            var sfxs = true;
            if(that.sfssq){
              if(key!="990000"){
                sfxs = true;
              }else{
                sfxs = false;
              }
            }

            if(sfxs){
              arr.push({id:key, text:province[key], pid:'86'});
              const city = res[key];
              Object.keys(city).map(key2=>{
                arr.push({id:key2, text:city[key2], pid:key});
                const qu = res[key2];
                Object.keys(qu).map(key3=>{
                  arr.push({id:key3, text:qu[key3], pid:key2});
                })
              })
            }

          })
          var opts = this.getDgXzqh(arr,'86',1);
          this.options = opts;
        })
    },
    getDgXzqh(list,pid,numberType){
      var ops = [];
      for(var i=0;i<list.length;i++){
        if(list[i].id=="330103"||list[i].id=="330104"||list[i].id=="330185"||list[i].id=="350402"||list[i].id=="350403"||list[i].id=="350427"||
        list[i].id=="450127"||list[i].id=="532331"||list[i].id=="610322"||list[i].id=="610928"){
          continue;
        }
        if(list[i].pid==pid){
          if(numberType==3){
            ops.push({value:list[i].id,label:list[i].text});
          }else{
            var childrens = this.getDgXzqh(list,list[i].id,numberType+1);          
            if(childrens.length==0){
              childrens=null;
            }
            ops.push({value:list[i].id.substr(0,numberType*2),label:list[i].text,children:childrens});
          }
          
        }
      }
      return ops;
    },
    getSsqText(code){
        // let shengStr = "";
        // let shiStr = "";
        // let qStr = "";
        // if(code.length>2){
        //   shengStr = code.substr(0,2);
        //   this.defaultValue = [shengStr];
        // }
        // if(code.length>4){
        //   shiStr = code.substr(0,4);
        //   this.defaultValue =  [shengStr,shiStr];
        // }
        // if(code.length>6){
        //   qStr = code.substr(0,6);
        //   this.defaultValue =  [shengStr,shiStr,qStr];
        // }
    }
  },
};
</script>